import request from "@/request";
import { getPageLang } from "../locales";

export type QuestionType = {
  issueTypeName: string;
  id: string;
};

export type CanCreateConversation = {
  content: string;
  hasActiveConversation: boolean;
  online: boolean;
  endTime: string;
  leftTime: string;
  nearEnd: boolean;
};

export const getQuestionType = () => {
  return request.get<QuestionType[]>("/cus/issueType/list");
};

/**
 * 判断当前用户是否能建开启IM聊天
 * @returns
 */
export const canCreateConversation = () => {
  return request.get<CanCreateConversation>(
    `/cus/dutyRoster/canCreateConversation?language=${getPageLang()}`,
  );
};
